import React from 'react';
import { Card, Badge, Col } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBolt, FaFire, FaUser, FaBuilding } from 'react-icons/fa';

const estados = {
    activa: { descrip: "ACTIVA", bg: "success" },
    baixa: { descrip: "BAJA", bg: "danger" },
    cancelada: { descrip: "CANCELADA", bg: "danger" },
    esborrany: { descrip: "BORRADOR", bg: "primary" },
    impagament: { descrip: "IMPAGA", bg: "danger" },
    modcontractual: { descrip: "MOD. CONTRACTUAL ABIERTA", bg: "danger" },
    pendent: { descrip: "PENDIENTE", bg: "danger" },
    tall: { descrip: "ALTA", bg: "danger" },
    validar: { descrip: "VALIDAR", bg: "danger" },
    saliente: { descrip: "SALIENTE", bg: "danger" },
};

// Targeta individual del llistat de contractes; usada a ContratosList. Navega al detall en clicar.
const ContractListCard = ({ contrato }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isElectric = contrato.sector_type === 'electrico';
    const sectorIcon = isElectric ? <FaBolt /> : <FaFire />;
    const sectorColor = isElectric ? 'var(--ab-primary-light)' : 'var(--ab-warning)';

    // data_baixa + activa = contracte en procés de baixa (es mostra com SALIENTE)
    const getStateBadge = (state, data_baixa) => {
        if (data_baixa && state === 'activa') {
            return <Badge pill bg="warning" text="dark">SALIENTE</Badge>;
        }
        const estado = estados[state] || { descrip: state?.toUpperCase() || "DESCONOCIDO", bg: "secondary" };
        return <Badge pill bg={estado.bg}>{estado.descrip}</Badge>;
    };

    return (
        <Col lg={4} md={6} className="mb-4">
            <Card
                className="h-100 border-0 shadow-sm hover-elevate transition-all rounded-4"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    const params = new URLSearchParams(location.search);
                    params.set('sector_type', contrato.sector_type);
                    navigate(`/contratos/contratos/${contrato.id}?${params.toString()}`);
                }}
            >
                <Card.Body className="p-4 d-flex flex-column">
                    {/* Header: Sector Icon + ID + Date */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center gap-2">
                            <div
                                className="d-flex align-items-center justify-content-center rounded-circle text-white"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    fontSize: '1.2rem',
                                    background: sectorColor
                                }}
                            >
                                {sectorIcon}
                            </div>
                            <div>
                                <h6 className="fw-bold mb-0 text-brand">#{contrato.name}</h6> {/* Assuming contrato.name is the friendly ID like 'CNT-xxx' */}
                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>Alta: {contrato.data_alta || '-'}</small>
                            </div>
                        </div>
                        {getStateBadge(contrato.state, contrato.data_baixa)}
                    </div>

                    {/* Content: Client Name */}
                    <div className="mb-3">
                        <h5 className="fw-bold text-dark mb-1 text-truncate" title={contrato.titular}>
                            {contrato.titular}
                        </h5>
                        <div className="d-flex gap-2">
                            {contrato.nif && (
                                <Badge pill bg="light" className="text-dark border">
                                    {contrato.nif}
                                </Badge>
                            )}
                        </div>
                    </div>

                    {/* Footer: CUPS + Agent */}
                    <div className="mt-auto pt-3 border-top">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-2 text-muted" title="CUPS">
                                <FaBuilding size={14} />
                                <span className="small" style={{ maxWidth: '170px' }}>
                                    {contrato.cups}
                                </span>
                            </div>

                            {contrato.prescriptor && (
                                <div className="d-flex align-items-center gap-2 text-muted" title="Agente">
                                    <FaUser size={14} />
                                    <span className="small text-truncate" style={{ maxWidth: '100px' }}>
                                        {contrato.prescriptor}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default ContractListCard;
